/**
*
*   Shopify Analytics
*       - An integration into hydrogen to push analytics to shopify
*
**/
'use client';


import Config from '@/config';
import secureLocalStorage from 'react-secure-storage';
import ShopifyTools from '@/libraries/shopify-tools/class';
import { sendGTMEvent } from '@next/third-parties/google';
import moment from 'moment-timezone';



/**
*
*   AnalyticTools
*       - Function to pass data to different layers
*
*   Params
*       n/a
*
*
**/
const AnalyticTools = (()=>{


	//The ID
	let id = moment().unix();


	//The Tools Object
	const Tools = {

		//Store the active customer
		customer: null,

		//The Shopify Cookies
		cookies: { y: null, s: null },

		//The Previous URL
		previous: null,

		/**
		*
		*   getId
		*       - Returns a unique id for the request
		*
		*   Params:
		*       n/a
		*
		*
		**/
		getId: () => ( id++ ),

		/**
		*
		*   slug
		*       - Create a Slug from a product name
		*
		*   Params:
		*       value: (String) The String to turn into into a slug
		*
		*
		**/
		slug: (value) => value.toLowerCase().replace(/ /g,'-').replace(/[-]+/g, '-').replace(/[^\w-]+/g,''),

		/**
		*
		*   getMetaUserData
		*       - Creates the Data to be parsed
		*
		*   Params:
		*       value: (String) The String to turn into into a slug
		*
		*
		**/
		getMetaUserData: () => ({
			external_id:    Tools.cookies?.y,
			em:             ( Tools.customer?.emailAddress?.emailAddress || Tools.customer?.email ),
			ph:             ( Tools.customer?.phoneNumber?.phoneNumber || Tools.customer?.phone ),
			fn:             Tools.customer?.firstName,
			ln:             Tools.customer?.lastName,
			ct:             Tools.customer?.defaultAddress?.city,
			st:             Tools.customer?.defaultAddress?.state,
			zp:             Tools.customer?.defaultAddress?.zip,
			country:        Tools.customer?.defaultAddress?.country
		}),

		/**
		*
		*   getGAUserData
		*       - Create a Slug from a product name
		*
		*   Params:
		*       value: (String) The String to turn into into a slug
		*
		*
		**/
		getGAUserData: () => ({
			client_id:      Tools.cookies?.y,
			user_id:        Tools.customer?.id,
			email:          ( Tools.customer?.emailAddress?.emailAddress || Tools.customer?.email ),
			phone:          ( Tools.customer?.phoneNumber?.phoneNumber || Tools.customer?.phone ),
			first_name:     Tools.customer?.firstName,
			last_name:      Tools.customer?.lastName,
			address1:       Tools.customer?.defaultAddress?.address1,
			address2:       Tools.customer?.defaultAddress?.address2,
			city:           Tools.customer?.defaultAddress?.city,
			country:        Tools.customer?.defaultAddress?.country,
			countryCode:    Tools.customer?.defaultAddress?.countryCode,
			province:       Tools.customer?.defaultAddress?.province,
			provinceCode:   Tools.customer?.defaultAddress?.provinceCode,
			zip:            Tools.customer?.defaultAddress?.zip,
			currency:       Config.currency
		}),

		/**
		*
		*   sendMeta
		*       - Sends a request to the Conversion API
		*
		*   Params:
		*       data: (Object) The Custom Content Data object to send
		*
		*
		**/
		sendMeta: async (type, data) => {
			return await fetch( '/api/analytics/meta' , {
				method: 'POST',
				body:   JSON.stringify({
					id: Tools.getId(),
					type: type,
					customer: ( typeof window != 'undefined' ? ( JSON.parse( secureLocalStorage.getItem('customer.meta') ) || {} ) : {} ),
					agent: window.navigator.userAgent,
					data: data
				})
			});
		}
	};


	//Interactive Object
	const Analytics = {

		/**
		*
		*   setCookies
		*       - Applies the Shopify Cookies
		*
		*   Params:
		*       cookies     (Object) The Shopify Cookies
		*
		**/
		setCookies: async (cookies) => Tools.cookies = cookies,

		/**
		*
		*  	track
		*       - Validates and Stores hashed user data for tracking (if not logged in)
		*
		*   Params:
		*      	data: 		(Object) The User Data
		* 		callback: 	(Function) The Callback Function
		*
		**/
		track: async (data, callback) => {

			//Only if the customer is not logged in
			if( !Tools.customer && data?.email ){

				//Get the Trackable customer
				const customer = await (
					await fetch( '/api/analytics' , {
						method: 'POST',
						body:   JSON.stringify( data )
					})
				).json();

				//If we were successful
				if( customer.result ){

					//Store the Meta Conversion API
					secureLocalStorage.setItem('customer.meta', JSON.stringify({
						external_id: Tools.cookies?.y,
						...customer.meta
					}) );

					//Reinitialize
					Analytics.init();

				}

			}

			//If we have a callback function
			if(callback) callback();

		},

		/**
		*
		*  	init
		*       - Initialized Meta
		*
		*   Params:
		*      	data: 		(Object) The User Data
		* 		callback: 	(Function) The Callback Function
		*
		**/
		init: async (customer) => {

			//Send the originalLocation to GTM
			sendGTMEvent({
				originalLocation: `${ document.location.protocol  }//${  document.location.hostname  }${ document.location.pathname  }${ document.location.search }`
			});

			//Google Consent Mode v2
			sendGTMEvent({
				event:              'consent_update',
				ad_storage:         'granted',
				analytics_storage:  'granted',
				ad_user_data:       'granted',
				ad_personalization: 'granted'
			});

			//
			if( window?.clarity ){

				//Enable Microsoft Clarity
				window.clarity('consentv2',{
					ad_Storage:         'granted',
					analytics_Storage:  'granted'
				});

			}

			//If the customer is logged in with an active email
			if(customer?.email){

				//Track the Cart Add in TripleWhale
				TriplePixel('Contact',{
					email: customer.email
				});

			}

/*
			//Initialize Facebook
			fbq('init', 1922962524680385 , (()=>{


				//Try to pull from current customer
				if( customer && Object.keys( customer ).length > 0 ){

					//Save the Customer
					Tools.customer = customer;

					console.log(Tools.customer);

					//Return Customer Data
					return Tools.getMetaUserData();

				}


				//Try to pull from a subscribe event
				let meta = ( typeof window != 'undefined' ? ( JSON.parse( secureLocalStorage.getItem('customer.meta') ) || {} ) : {} );


				//If we have meta storage, return that
				if( Object.keys( meta ).length > 0 )
					return {
						external_id: Tools.cookies?.y,
						em: meta.em,
						fn: meta.fn,
						ln: meta.ln,
						ph: meta.ph,
						ct: meta.ct,
						st: meta.st,
						zp: meta.zp,
						country: meta.country
					};


				//No Customer Data stored
				return {};


			})() );
*/

		},



		/**
		*
		*   pageView
		*       - Sends a Page View Event
		*
		*   Params:
		*      	payload: 	(Object) The Analytics Payload for Shopify
		* 		locale: 	(String) The Page Locale
		*
		**/
		pageView: () => {

			//Reset ecommerce tag
			sendGTMEvent({
				ecommerce: null
			});

			//Keeping this temporarily
			sendGTMEvent({
				event:'page_view',
				...Tools.getGAUserData()
			});

			//Send Google Page View Eevent
			sendGTMEvent({
				event:'custom_page_view',
				new_url: document.location.href,
				new_page_title: document.title,
				prev_page_url: document.referrer,
				...Tools.getGAUserData()
			});

			//Update the previous
			Tools.previous = document.location.href;
/*
			//Send a Page View
			fbq('track', 'PageView', {
				...Tools.getMetaUserData()
			});
*/
		},



		/**
		*
		*   viewProduct
		*       - Sends a Product View Event
		*
		*   Params:
		*       product: (Object) The Product Object
		*
		**/
		viewProduct: async (product) => {

			//Reset ecommerce tag
			sendGTMEvent({
				ecommerce: null
			});

			//Send Google
			sendGTMEvent({
				event: 'view_item',
				...Tools.getGAUserData(),
				ecommerce: {
					currency:   Config.currency,
					value:      product.variant.price.amount,
					items:      [{
						item_id:        ShopifyTools.id( product.id ),
						item_name:      product.title,
						item_brand:     product.vendor,
						item_variant:   product.variant.title,
						price:          product.variant.price.amount,
						currency:       Config.currency
					}]
				}
			});

/*
			//Send to Conversions API
			fbq('track','ViewContent',{
				...Tools.getMetaUserData(),
				content_name:       product.title + ' ' + product.variant.title,
				content_category:   product.productType,
				content_ids:        [ ShopifyTools.id( product.id ) , ShopifyTools.id( product.variant.id ) ],
				content_type:       'product',
				value:              product.variant.price.amount,
				currency:           Config.currency
			});
*/
			//Klaviyo - Track the View Product Event
			( window._learnq || [] ).push(['track', 'Viewed Product', product ]);

			/*
			//Send to Conversions API
			Tools.sendMeta('ViewContent', {
				content_name:       product.title + ' ' + product.variant.title,
				content_category:   product.productType,
				content_ids:        [ product.id , product.variant.id ],
				content_type:       'product',
				value:              product.variant.price.amount,
				currency:           Config.currency
			});
			*/


		},



		/**
		*
		*   addToCart
		*       - Sends an Add To Cart Event
		*
		*   Params:
		*       product: (Object) The Product Object
		*
		**/
		addToCart: (product, quantity) => {

			//Reset ecommerce tag
			sendGTMEvent({
				ecommerce: null
			});

			//Send Google
			sendGTMEvent({
				event:      'add_to_cart',
				...Tools.getGAUserData(),
				ecommerce: {
					currency:   Config.currency,
					value:      ( product.variant.price.amount * quantity ),
					items:      [{
						item_id:            ShopifyTools.id( product.id ),
						item_name:          product.variant.title,
						item_brand:         product.vendor,
						item_variant:       product.variant.title,
						item_variant_id:    ShopifyTools.id( product.variant.id ),
						price:              product.variant.price.amount,
						currency:           Config.currency,
						quantity:           quantity
					}]
				}
			});

/*
			//Send to Conversions API
			fbq('track','AddToCart',{
				...Tools.getMetaUserData(),
				content_name:       product.title + ' ' + product.variant.title,
				content_category:   product.productType,
				content_ids:        [ ShopifyTools.id( product.id ) , ShopifyTools.id( product.variant.id ) ],
				content_type:       'product',
				value:              ( product.variant.price.amount * quantity ),
				currency:           Config.currency
			});
*/
			/*
			//Send to Conversions API
			Tools.sendMeta('AddToCart', {
				content_name:       product.title + ' ' + product.variant.title,
				content_category:   product.productType,
				content_ids:        [ product.id , product.variant.id ],
				content_type:       'product',
				value:              ( product.variant.price.amount * quantity ),
				currency:           Config.currency
			});
			*/


		},



		/**
		*
		*   beginCheckout
		*       - Sends a Begin Checkout Event
		*
		*   Params:
		*       product: (Object) The Cart
		*
		**/
		beginCheckout: (cartId , data) => {


			/*
			//Send Google
			sendGAEvent('event', 'begin_checkout', data);


			//Send to Conversions API
			fbq('track','InitiateCheckout',{
				content_ids: [ cartId ]
			});


			//Send to Conversions API
			Tools.sendMeta('InitiateCheckout', {
				content_ids: [ cartId ]
			});
			*/


		},



		/**
		*
		*   purchase
		*       - Sends a Purchase Event
		*
		*   Params:
		*       product: (Object) The Product Object
		*
		**/
		purchase: (cart) => {



			/*
			//Send Google
			sendGAEvent('event','purchase',{
				currency:   cart.totalPriceSet.currencyCode,
				value:      cart.subtotalPriceSet.amount,
				tax:        cart.totalTaxSet.amount,
				shipping:   cart.totalShippingPriceSet.amount,
				items:      cart.lineItems.map( line => ({
					item_id:        line.product.id,
					item_name:      line.product.title,
					item_brand:     line.product.vendor,
					item_variant:   line.variant.title,
					price:          line.variant.price,
					quantity:       line.quantity
				}))
			});


			//Send to Conversions API
			fbq('track','Purchase',{
				value:              cart.subtotalPriceSet.amount,
				currency:           cart.totalPriceSet.currencyCode,
				content_type:       'product',
				contents:           cart.lineItems.map( line => ({
					id:                 line.variant.id,
					quantity:           line.quantity
				}))
			});


			//Send to Conversions API
			Tools.sendMeta('Purchase', {
				value:              cart.subtotalPriceSet.amount,
				currency:           cart.totalPriceSet.currencyCode,
				content_type:       'product',
				contents:           cart.lineItems.map( line => ({
					id:                 line.variant.id,
					quantity:           line.quantity
				}))
			});
			*/


		},



		/**
		*
		*   newsletter
		*       - Sends a Newsletter Subscribe Event
		*
		*   Params:
		*       type: (String) The Newsletter Type
		*
		**/
		newsletter: (type, email) => {

			//Reset ecommerce tag
			sendGTMEvent({
				ecommerce: null
			});

			//Send Google
			sendGTMEvent({
				event:      'sign_up',
				...Tools.getGAUserData(),
				...{ email: email },
				type:       'newsletter',
				category:   type
			});

			//Track the Customer in TripleWhale
			TriplePixel('Contact',{
				email: email
			});

/*
			//Send to Conversions API
			fbq('track','Subscribe',{
				...Tools.getMetaUserData(),
				...{ email: email },
				content_type:       'newsletter',
				value:              0,
				currency:           Config.currency,
			});
*/

			/*
			//Send to Conversion API
			Tools.sendMeta('subscribe',{
				content_type:       'newsletter',
				value:              0,
				currency:           Config.currency
			});
			*/


		},



		/**
		*
		*   inquiry
		*       - Sends a Lead Event
		*
		*   Params:
		*       product: (Object) The Event Type
		*
		**/
		inquiry: (value, type) => {

			//Reset ecommerce tag
			sendGTMEvent({
				ecommerce: null
			});

			//Send Google
			sendGTMEvent({
				event:          'generate_lead',
				...Tools.getGAUserData(),
				currency: 		Config.currency,
				value:  		value,
				category:  		type,
				lead_source:  	'Website'
			});

/*
			//Send to Conversions API
			fbq('track','SubmitApplication',{
				...Tools.getMetaUserData(),
				value:              value,
				currency:           Config.currency,
				content_name:       type,
				content_category:   'service',
				content_ids:        [ Tools.slug( type ) ],
				content_type:       'product'
			});
*/
/*
			//Send to Conversions API
			Tools.sendMeta('SubmitApplication',{
				value:              value,
				currency:           Config.currency,
				content_name:       type,
				content_category:   'service',
				content_ids:        [ Tools.slug( type ) ],
				content_type:       'product'
			});
			*/


			//Linkedin
			window.lintrk('track', { conversion_id: 19710684 });


			//Klaviyo - Track the View Product Event
			( window._learnq || [] ).push(['track', 'Inquiry', {
				value:  value,
				type:   type
			} ]);

		},



		/**
		*
		*   generic
		*       - Tracks a generic event and data
		*
		*   Params:
		*       product: (Object) The Event Type
		*
		**/
		generic: (event, data) => {

			//Klaviyo - Track the View Product Event
			( window._learnq || [] ).push([ 'track', event, data ]);

		}



	};


	//Return the Application functions
	return Analytics;


})();



//Export the cookies
export { AnalyticTools };
